import { persistCombineReducers } from 'reduxjs-toolkit-persist';
import autoMergeLevel1 from 'reduxjs-toolkit-persist/lib/stateReconciler/autoMergeLevel1';
import { PERSIST_STORE } from 'src/feature-flags_';
import { createLocalforageStorage } from 'src/utils/local-storage';
import * as reducers from './reducers';

const whitelist: (keyof typeof reducers)[] = PERSIST_STORE
  ? ['blocks', 'collectionViews', 'comments', 'discussions', 'users']
  : [];

const storage = createLocalforageStorage();

export const persistReducers = persistCombineReducers(
  {
    key: 'store',
    storage,
    stateReconciler: autoMergeLevel1,
    whitelist,
    throttle: 10000,
    version: 1,
  },
  reducers
);
